import { dictList } from "@/service/user";
import store from "store2";
import { getBrowerLang } from "@/utils/util";
export default {
  state: {
    appCode: "",
    language: store.get("language") || getBrowerLang(),
    unitCategoryMap: [],
    unitColorMap: store.get("unitColorMap") || [],
    isMobile: false
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language;
      store.set("language", language);
    },
    setUnitCategoryMap(state, unitCategoryMap) {
      state.unitCategoryMap = unitCategoryMap;
    },
    setUnitColorMap(state, unitColorMap) {
      state.unitColorMap = unitColorMap;
      store.set("unitColorMap", unitColorMap);
    },
    setIsMobile(state, isMobile) {
      state.isMobile = isMobile;
    }
  },
  actions: {
    async getDictList({
      commit
    }) {
      try {
        let {
          data: {
            retVal
          }
        } = await dictList({
          category: "UNIT_TYPE"
        });
        commit("setUnitCategoryMap", retVal);
      } catch (error) {
        console.error("获取字典列表失败:", error);
      }
    }
  }
};